import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PageSlotModule } from '@spartacus/storefront';
import { SikoBreakpointObserverService } from '@siko/common';
import { B2bCommonModule } from '@siko/shared/b2b-common.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-blog-list-template',
    templateUrl: './blog-list-outlet.component.html',
    styleUrls: ['./blog-list-outlet.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [B2bCommonModule, PageSlotModule],
})
export class SikoBlogListOutletComponent {
    constructor(public breakpointObserver: SikoBreakpointObserverService) {}
}
